import MobileApi from 'lib/MobileApi';
import { useEffect, useRef } from 'react';
// eslint-disable-next-line import/no-unresolved
import { useVideoController } from '@nbcnews/omega-player/context/videoController';
// eslint-disable-next-line import/no-unresolved
import { useVideoTime } from '@nbcnews/omega-player/context/state/time';


/**
 * Hook to set up a communication channel for chromeless video players.
 * @param {boolean} autoplayEnabled - Flag indicating if autoplay is enabled for the video.
 */
export function useChromelessCommunicationChannel(autoplayEnabled = false) {
  const { play, pause, setMute } = useVideoController();
  const { seekToLiveEdge } = useVideoTime();
  const wasPausedThroughNativeBridgeRef = useRef(false);

  useEffect(() => {
    MobileApi.getVideoStatus(({ pipActive }) => {
      if (pipActive) {
        pause();
      }
    });

    MobileApi.playbackAction((playbackAction) => {
      if (playbackAction === 'play') {
        if (autoplayEnabled || wasPausedThroughNativeBridgeRef.current) {
          play();
        }
      } else if (playbackAction === 'pause') {
        wasPausedThroughNativeBridgeRef.current = true;
        pause();
      } else if (playbackAction === 'mute') {
        setMute(true);
      } else if (playbackAction === 'unmute') {
        setMute(false);
      } else if (playbackAction === 'seekToLiveEdge') {
        seekToLiveEdge();
      }
    });
  }, []);
}
